import React from 'react';

import PropTypes from 'prop-types';

export const HeaderCircleIcon = ({ className }) => (
  <svg
    width="241"
    height="242"
    viewBox="0 0 241 242"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M197.194 140.636C195.762 140.296 195.025 138.905 195.342 137.462L196.122 133.92L204.48 135.891L203.756 139.182C203.445 140.592 202.243 141.495 200.848 141.17C200.133 141.002 199.635 140.568 199.348 139.988C198.818 140.565 198.066 140.838 197.194 140.636ZM197.66 139.027C198.222 139.158 198.729 138.85 198.853 138.293L199.268 136.395L197.3 135.928L196.885 137.826C196.762 138.388 197.088 138.889 197.664 139.025L197.66 139.027ZM202.578 137.174L200.739 136.744L200.376 138.392C200.262 138.903 200.573 139.377 201.098 139.505C201.621 139.627 202.099 139.352 202.213 138.83L202.576 137.181L202.578 137.174Z"
      fill="#0F2E52"
    />
    <path
      d="M197.147 141.996L202.64 143.796L202.144 145.391L196.779 143.635C195.986 143.374 195.26 143.598 194.921 144.696C194.579 145.788 195.042 146.405 195.835 146.666L201.203 148.427L200.701 150.031L195.208 148.231C193.447 147.655 192.788 145.977 193.346 144.185C193.905 142.405 195.391 141.429 197.152 142.005L197.147 141.996Z"
      fill="#0F2E52"
    />
    <path
      d="M199.161 153.751L191.217 150.466L191.84 148.904L199.783 152.189L199.161 153.751Z"
      fill="#0F2E52"
    />
    <path
      d="M189.872 157.278L188.414 156.565L190.523 152.104L198.266 155.878L197.55 157.397L191.27 154.335L189.881 157.273L189.872 157.278Z"
      fill="#0F2E52"
    />
    <path
      d="M187.713 166.201C185.646 164.932 184.943 162.447 186.148 160.438L187.885 157.539L195.228 162.044L193.491 164.943C192.281 166.955 189.78 167.471 187.709 166.204L187.713 166.201ZM188.539 164.824C189.892 165.656 191.349 165.351 192.11 164.09L192.984 162.63L188.412 159.824L187.539 161.285C186.785 162.548 187.189 163.997 188.546 164.827L188.539 164.824Z"
      fill="#0F2E52"
    />
    <path
      d="M188.229 172.955L187.065 174.276L181.213 171.242L184.818 176.829L183.87 177.902L177.914 174.988L181.616 180.465L180.453 181.786L175.581 174.261L176.842 172.831L182.154 175.417L178.954 170.437L180.215 169.006L188.236 172.957L188.229 172.955Z"
      fill="#0F2E52"
    />
    <path
      d="M177.603 184.147L171.793 177.81L173.021 176.678L178.833 183.019L177.605 184.151L177.603 184.147Z"
      fill="#0F2E52"
    />
    <path
      d="M170.458 187.983L172.246 186.551L167.865 181.098L169.17 180.048L173.551 185.501L175.326 184.075L176.345 185.344L171.477 189.252L170.458 187.983Z"
      fill="#0F2E52"
    />
    <path
      d="M164.473 193.953L159.739 186.747L161.131 185.838L163.095 188.821L165.735 187.097L163.776 184.112L165.178 183.198L169.912 190.404L168.511 191.317L166.629 188.456L163.989 190.18L165.871 193.041L164.478 193.95L164.473 193.953Z"
      fill="#0F2E52"
    />
    <path
      d="M151.497 192.658L154.582 191.256L154.393 189.636L156.04 188.885L156.961 197.935L155.072 198.795L148.727 192.216L150.383 191.461L151.502 192.656L151.497 192.658ZM152.642 193.881L155.186 196.595L154.764 192.915L152.642 193.881Z"
      fill="#0F2E52"
    />
    <path
      d="M141.331 201.921L143.533 201.275L141.497 194.599L143.104 194.126L145.141 200.802L147.334 200.161L147.805 201.712L141.802 203.472L141.331 201.921Z"
      fill="#0F2E52"
    />
    <path
      d="M133.39 198.136L133.051 196.549L138.216 195.518L140.005 203.928L134.897 204.947L134.558 203.36L138.021 202.67L137.643 200.882L134.479 201.514L134.147 199.952L137.312 199.32L136.91 197.433L133.39 198.136Z"
      fill="#0F2E52"
    />
    <path
      d="M126.859 198.846L130.243 198.514L130.58 196.927L132.388 196.752L130.37 205.567L128.299 205.77L124.364 197.529L126.184 197.354L126.864 198.844L126.859 198.846ZM127.557 200.367L129.111 203.74L129.889 200.144L127.559 200.372L127.557 200.367Z"
      fill="#0F2E52"
    />
    <path
      d="M115.059 197.456L116.734 197.493L116.685 203.054L119.125 199.13L119.318 199.134L121.69 203.162L121.735 197.615L123.423 197.656L123.353 206.23L121.619 206.19L119.195 202.077L116.719 206.073L114.985 206.033L115.055 197.458L115.059 197.456Z"
      fill="#0F2E52"
    />
    <path
      d="M103.422 202.801L105.702 203.203L106.801 196.354L108.463 196.649L107.363 203.498L109.629 203.896L109.374 205.486L103.167 204.392L103.422 202.801Z"
      fill="#0F2E52"
    />
    <path
      d="M95.0293 202.302L97.1862 194.039L98.8025 194.487L97.9083 197.913L100.979 198.765L101.873 195.339L103.504 195.791L101.347 204.054L99.7164 203.602L100.572 200.319L97.5009 199.467L96.6457 202.75L95.0293 202.302Z"
      fill="#0F2E52"
    />
    <path
      d="M90.3955 193.159L93.5808 194.419L94.6041 193.172L96.306 193.844L90.4793 200.712L88.5262 199.938L88.7474 190.855L90.4587 191.534L90.3955 193.159ZM90.3289 194.821L90.189 198.512L92.5238 195.69L90.3289 194.821Z"
      fill="#0F2E52"
    />
    <path
      d="M80.3413 194.369L82.4161 195.413L85.4524 189.2L86.9718 189.963L83.9355 196.176L86.0009 197.213L85.2958 198.656L79.6361 195.811L80.3413 194.369Z"
      fill="#0F2E52"
    />
    <path
      d="M77.5847 189.791C76.1762 191.844 73.5462 192.369 71.4073 190.868C70.1137 189.963 69.4203 188.514 69.5036 187.089L71.1794 187.237C71.0967 188.099 71.5211 188.959 72.3309 189.521C73.716 190.489 75.276 190.17 76.2042 188.821C77.1257 187.481 76.8709 185.889 75.4882 184.926C74.6784 184.364 73.7247 184.258 72.9698 184.632L72.244 183.1C73.5269 182.512 75.1155 182.659 76.4184 183.57C78.5594 185.064 78.9933 187.738 77.5868 189.784L77.5847 189.791Z"
      fill="#0F2E52"
    />
    <path
      d="M67.6959 178.775L70.2861 181.043L71.6801 180.226L73.0626 181.437L65.2171 185.874L63.629 184.485L66.9202 176.056L68.3122 177.273L67.7004 178.773L67.6959 178.775ZM67.0668 180.307L65.6793 183.715L68.8465 181.871L67.0668 180.307Z"
      fill="#0F2E52"
    />
    <path
      d="M62.1076 175.245L62.9896 176.191L65.1439 174.179L66.3017 175.424L60.091 181.23L57.7374 178.7C56.6534 177.538 56.7017 175.733 57.8368 174.673C58.6174 173.946 59.781 173.784 60.7794 174.2L61.818 170.609L63.0685 171.953L62.0982 175.238L62.1076 175.245ZM61.917 177.195L60.7236 175.915C60.2861 175.443 59.5145 175.44 59.0016 175.921C58.4887 176.402 58.451 177.165 58.8861 177.633L60.0794 178.912L61.917 177.195Z"
      fill="#0F2E52"
    />
    <path
      d="M56.6417 166.525L57.9138 165.545L61.1856 169.77L54.4551 174.968L51.2192 170.788L52.4913 169.808L54.6822 172.639L56.1135 171.533L54.1121 168.948L55.3641 167.984L57.3655 170.569L58.8754 169.404L56.6462 166.523L56.6417 166.525Z"
      fill="#0F2E52"
    />
    <path
      d="M55.8093 165.931L54.3159 165.153C54.8181 164.467 54.922 163.685 54.3417 162.784C53.788 161.921 53.2386 161.847 52.8352 162.1C52.3035 162.439 52.4082 163.058 52.7959 164.336C53.1917 165.651 53.4215 167.025 52.0608 167.894C50.7067 168.754 49.1923 168.11 48.3918 166.861C47.6252 165.665 47.6437 164.366 48.3388 163.238L49.7974 164.005C49.4214 164.614 49.2922 165.25 49.766 165.985C50.153 166.59 50.6865 166.743 51.0989 166.484C51.5405 166.205 51.5935 165.773 51.2186 164.464C50.8391 163.081 50.4316 161.614 51.8984 160.683C53.2434 159.828 54.7647 160.398 55.7539 161.946C56.7044 163.432 56.6256 164.856 55.8117 165.936L55.8093 165.931Z"
      fill="#0F2E52"
    />
    <path
      d="M48.0868 157.507C47.266 157.898 46.2605 157.533 45.8455 156.68C45.4427 155.851 45.7828 154.852 46.6037 154.461C47.447 154.058 48.4567 154.41 48.8595 155.239C49.2745 156.091 48.9302 157.104 48.0868 157.507Z"
      fill="#0F2E52"
    />
    <path
      d="M44.2175 143.074C45.6046 142.613 46.9516 143.421 47.4421 144.826L48.6412 148.284L40.5578 150.989L39.4422 147.774C38.9689 146.401 39.5099 144.985 40.8605 144.532C41.554 144.301 42.1963 144.408 42.7429 144.759C42.8836 143.981 43.3761 143.353 44.2196 143.067L44.2175 143.074ZM41.4861 148.889L43.2642 148.292L42.7076 146.687C42.5332 146.187 42.0243 145.94 41.5197 146.112C41.008 146.282 40.7547 146.773 40.9341 147.282L41.4906 148.887L41.4861 148.889ZM44.6624 144.708C44.1212 144.888 43.8509 145.423 44.0428 145.966L44.6854 147.819L46.5908 147.179L45.9482 145.326C45.7608 144.78 45.2192 144.515 44.6645 144.701L44.6624 144.708Z"
      fill="#0F2E52"
    />
    <path
      d="M43.6117 141.923L38.0122 143.18L37.6225 141.54L43.0919 140.311C43.8994 140.131 44.405 139.561 44.135 138.438C43.8696 137.313 43.1574 137.02 42.3499 137.2L36.8804 138.429L36.4903 136.778L42.0898 135.521C43.8849 135.12 45.3032 136.235 45.743 138.077C46.178 139.909 45.4113 141.519 43.6162 141.92L43.6117 141.923Z"
      fill="#0F2E52"
    />
    <path
      d="M35.8969 132.82L44.3628 131.587L44.6325 133.265L36.1665 134.498L35.8969 132.82Z"
      fill="#0F2E52"
    />
    <path
      d="M42.0411 125.006L43.6476 124.875L44.1229 129.837L35.59 130.53L35.428 128.837L42.3544 128.274L42.0386 125.001L42.0411 125.006Z"
      fill="#0F2E52"
    />
    <path
      d="M39.3425 116.239C41.7476 116.277 43.6161 118.073 43.6132 120.439L43.6112 123.847L35.0567 123.705L35.0587 120.298C35.0616 117.932 36.9305 116.198 39.3425 116.239ZM39.3388 117.856C37.763 117.832 36.677 118.842 36.6713 120.326L36.6685 122.043L41.9931 122.13L41.996 120.413C41.9972 118.932 40.91 117.883 39.3343 117.858L39.3388 117.856Z"
      fill="#0F2E52"
    />
    <path
      d="M35.517 110.765L35.8358 109.023L42.3632 108.645L36.4496 105.657L36.7053 104.241L43.2645 103.706L37.3233 100.861L37.6421 99.1187L45.6221 103.137L45.2757 105.022L39.4381 105.51L44.7036 108.185L44.3597 110.075L35.5239 110.767L35.517 110.765Z"
      fill="#0F2E52"
    />
    <path
      d="M38.858 95.6544L47.0753 98.1557L46.6078 99.7713L38.3905 97.27L38.858 95.6544Z"
      fill="#0F2E52"
    />
    <path
      d="M43.0077 88.7044L42.2204 90.8685L48.7454 93.3351L48.1738 94.9175L41.6487 92.4509L40.868 94.6056L39.3535 94.0342L41.4932 88.1331L43.0101 88.709L43.0077 88.7044Z"
      fill="#0F2E52"
    />
    <path
      d="M45.0819 80.5158L52.797 84.3214L52.0782 85.8233L48.8817 84.2481L47.515 87.1034L50.7115 88.6786L49.9885 90.1945L42.2734 86.3888L42.9964 84.873L46.0601 86.3837L47.4267 83.5284L44.3631 82.0177L45.0819 80.5158Z"
      fill="#0F2E52"
    />
    <path
      d="M56.8807 75.0334L54.9694 77.8296L55.9559 79.1345L54.9321 80.627L49.539 73.2514L50.7094 71.5356L59.467 73.9869L58.4391 75.4933L56.8783 75.0288L56.8807 75.0334ZM55.2852 74.558L51.7355 73.5097L53.9654 76.4812L55.2783 74.5558L55.2852 74.558Z"
      fill="#0F2E52"
    />
    <path
      d="M60.9078 61.8556L59.3595 63.542L64.4903 68.2896L63.3584 69.5229L58.2276 64.7752L56.6883 66.4568L55.4983 65.354L59.7178 60.7529L60.9078 61.8556Z"
      fill="#0F2E52"
    />
    <path
      d="M69.6445 61.0968L70.7372 62.2981L66.8631 65.8411L61.0576 59.4652L64.8895 55.962L65.9822 57.1633L63.389 59.5347L64.6243 60.8947L66.997 58.7272L68.0755 59.9126L65.7028 62.0801L67.0046 63.5104L69.6445 61.0968Z"
      fill="#0F2E52"
    />
    <path
      d="M74.9264 57.1245L72.2126 59.1446L72.7343 60.6944L71.2867 61.7727L68.5036 53.0919L70.1664 51.8535L77.7227 56.9792L76.2615 58.0646L74.9219 57.1269L74.9264 57.1245ZM73.5561 56.1619L70.511 54.0347L71.6872 57.5557L73.5516 56.1643L73.5561 56.1619Z"
      fill="#0F2E52"
    />
    <path
      d="M85.7432 52.2923L84.2982 53.1178L81.4936 48.2815L81.4279 52.9327L81.2563 53.0231L77.1793 50.7644L79.9791 55.5916L78.525 56.4218L74.2025 48.962L75.6993 48.1034L79.8584 50.4183L79.924 45.6911L81.4207 44.8325L85.7432 52.2923Z"
      fill="#0F2E52"
    />
    <path
      d="M92.988 41.6934L90.846 42.5178L93.4153 49.0128L91.853 49.6138L89.2836 43.1188L87.1506 43.9385L86.5526 42.4302L92.39 40.185L92.988 41.6934Z"
      fill="#0F2E52"
    />
    <path
      d="M100.474 37.8133L102.854 46.0855L101.247 46.5287L100.259 43.1017L97.2102 43.9417L98.1975 47.3687L96.5785 47.8122L94.1987 39.54L95.8177 39.0966L96.7638 42.3816L99.8129 41.5416L98.8668 38.2566L100.474 37.8133Z"
      fill="#0F2E52"
    />
    <path
      d="M109.158 43.3532L105.804 43.892L105.564 45.4976L103.771 45.7873L105.237 36.8484L107.292 36.5198L111.728 44.5073L109.924 44.7972L109.153 43.3556L109.158 43.3532ZM108.368 41.8752L106.609 38.6045L106.059 42.2494L108.368 41.8752Z"
      fill="#0F2E52"
    />
    <path
      d="M117.161 37.1463L114.864 37.3039L115.445 44.2402L113.768 44.3577L113.188 37.4214L110.903 37.5789L110.769 35.966L117.03 35.5379L117.164 37.1508L117.161 37.1463Z"
      fill="#0F2E52"
    />
    <path
      d="M121.952 39.6754C122.107 37.1714 124.078 35.372 126.667 35.571C128.225 35.6926 129.557 36.5941 130.211 37.8709L128.707 38.5983C128.338 37.8098 127.541 37.2817 126.563 37.2058C124.892 37.0791 123.724 38.1511 123.622 39.802C123.521 41.4414 124.545 42.6866 126.215 42.8133C127.193 42.8892 128.062 42.4901 128.508 41.7756L129.904 42.7314C129.11 43.8985 127.683 44.5855 126.107 44.4619C123.523 44.2606 121.788 42.1611 121.943 39.6686L121.952 39.6754Z"
      fill="#0F2E52"
    />
    <path
      d="M136.03 44.1126L132.671 43.4774L131.904 44.8994L130.11 44.563L134.518 36.695L136.578 37.0846L138.077 46.0706L136.269 45.7298L136.028 44.1195L136.03 44.1126ZM135.785 42.4633L135.228 38.8018L133.474 42.0249L135.785 42.4633Z"
      fill="#0F2E52"
    />
    <path
      d="M142.65 44.2668L141.413 43.9005L140.614 46.7545L138.99 46.2703L141.301 38.0529L144.594 39.032C146.111 39.4787 146.989 41.0687 146.571 42.5697C146.278 43.6012 145.373 44.3414 144.309 44.4925L145.259 48.1324L143.506 47.6112L142.65 44.2668ZM141.815 42.4781L143.485 42.973C144.096 43.1539 144.756 42.7655 144.945 42.0809C145.137 41.401 144.781 40.7232 144.169 40.5422L142.5 40.0473L141.815 42.4781Z"
      fill="#0F2E52"
    />
    <path
      d="M151.81 48.9629L151.236 50.4652L146.297 48.4899L149.357 40.5283L154.237 42.4816L153.66 43.9793L150.354 42.6542L149.703 44.349L152.726 45.5544L152.155 47.0313L149.132 45.8259L148.447 47.6088L151.812 48.956L151.81 48.9629Z"
      fill="#0F2E52"
    />
    <path
      d="M152.879 49.0162L154.545 48.9172C154.466 49.7663 154.781 50.4961 155.736 50.9825C156.648 51.4443 157.155 51.2239 157.362 50.7989C157.643 50.2298 157.235 49.7481 156.253 48.8428C155.245 47.9103 154.348 46.8377 155.064 45.3836C155.776 43.9433 157.39 43.7254 158.709 44.3947C159.971 45.035 160.618 46.1693 160.607 47.5035L158.975 47.5904C158.985 46.8714 158.772 46.2575 157.988 45.8627C157.354 45.5415 156.818 45.677 156.6 46.1138C156.369 46.5807 156.538 46.9834 157.533 47.9231C158.558 48.9221 159.657 49.9821 158.885 51.5478C158.18 52.9787 156.598 53.2675 154.962 52.4376C153.396 51.641 152.736 50.3618 152.879 49.0162Z"
      fill="#0F2E52"
    />
    <path
      d="M163.792 52.2937C164.294 51.5322 165.334 51.3353 166.12 51.8636C166.887 52.3783 167.106 53.4158 166.604 54.1773C166.092 54.9621 165.052 55.1705 164.287 54.6603C163.497 54.1344 163.28 53.0784 163.792 52.2937Z"
      fill="#0F2E52"
    />
    <path
      d="M171.95 63.8379L172.519 59.5396L168.392 60.7879L167.644 60.1458L172.635 58.6411L173.282 53.7746L174.021 54.4099L173.504 58.3825L177.319 57.2338L178.058 57.8691L173.381 59.2902L172.701 64.4846L171.953 63.8425L171.95 63.8379Z"
      fill="#0F2E52"
    />
    <path
      d="M179.034 71.0578L178.443 70.4271L183.692 65.4789L178.002 66.6906L177.919 66.5998L179.472 60.9825L174.222 65.9307L173.63 65.3L179.817 59.4724L180.549 60.2574L179.07 65.6016L184.479 64.4498L185.211 65.2348L179.025 71.0625L179.034 71.0578Z"
      fill="#0F2E52"
    />
    <path
      d="M184.889 75.3242L182.439 72.0402L180.283 72.6431L179.736 71.9121L188.543 69.4929L189.073 70.2034L184.237 77.9403L183.69 77.2093L184.887 75.3197L184.889 75.3242ZM185.346 74.5973L187.961 70.4847L183.266 71.8098L185.346 74.5973Z"
      fill="#0F2E52"
    />
    <path
      d="M189.445 79.9928L188.193 77.9219L185.273 79.6653L184.827 78.9278L192.126 74.5612L193.909 77.5181C194.652 78.7443 194.267 80.3234 193.061 81.0468C192.069 81.6398 190.818 81.4668 190.001 80.7077L188.077 84.3165L187.568 83.4716L189.445 79.9928ZM188.884 77.5115L190.22 79.7309C190.713 80.5437 191.792 80.8072 192.617 80.3139C193.452 79.8157 193.716 78.7505 193.224 77.9377L191.883 75.7206L188.879 77.5138L188.884 77.5115Z"
      fill="#0F2E52"
    />
    <path
      d="M197.887 86.8646L196.722 84.4776L189.766 87.8135L189.385 87.0354L196.345 83.6972L195.18 81.3102L195.904 80.9637L198.614 86.5111L197.889 86.8576L197.887 86.8646Z"
      fill="#0F2E52"
    />
    <path
      d="M193.885 95.6351L193.133 95.9201L191.387 91.4347L199.364 88.4103L199.677 89.2138L192.452 91.9531L193.885 95.6351Z"
      fill="#0F2E52"
    />
    <path
      d="M196.98 101.583L195.853 97.6539L193.613 97.4397L193.364 96.5629L202.504 97.4953L202.745 98.3468L195.427 103.783L195.179 102.906L196.98 101.583ZM197.669 101.073L201.598 98.1951L196.713 97.7342L197.669 101.073Z"
      fill="#0F2E52"
    />
    <path
      d="M199.032 110.603C197.734 110.818 196.495 109.942 196.258 108.632L195.594 104.94L204.018 103.536L204.632 106.95C204.858 108.208 204.016 109.395 202.777 109.603C201.996 109.733 201.288 109.45 200.807 108.907C200.616 109.763 199.967 110.445 199.029 110.598L199.032 110.603ZM198.881 109.757C199.738 109.616 200.31 108.823 200.16 107.988L199.646 105.142L196.54 105.659L197.054 108.505C197.204 109.34 198.01 109.905 198.876 109.759L198.881 109.757ZM203.381 104.522L200.444 105.009L200.907 107.577C201.049 108.363 201.815 108.897 202.633 108.759C203.438 108.628 203.986 107.876 203.842 107.086L203.381 104.522Z"
      fill="#0F2E52"
    />
    <path
      d="M198.674 111.784L199.16 112.488C198.161 112.862 197.571 113.718 197.687 115.062C197.795 116.358 198.475 117.036 199.388 116.977C200.376 116.908 200.622 116.046 200.928 114.755C201.277 113.329 201.528 111.956 203.098 111.849C204.595 111.746 205.537 112.901 205.657 114.319C205.773 115.728 205.027 116.759 204.056 117.271L203.593 116.578C204.332 116.206 204.923 115.503 204.83 114.374C204.744 113.348 204.145 112.638 203.208 112.705C202.282 112.771 202.053 113.524 201.771 114.709C201.392 116.296 201.065 117.722 199.484 117.829C198.021 117.931 196.998 116.819 196.854 115.108C196.724 113.531 197.416 112.312 198.674 111.784Z"
      fill="#0F2E52"
    />
    <path
      d="M201.486 122.647C202.403 122.696 203.12 123.495 203.083 124.433C203.048 125.353 202.278 126.057 201.363 126.012C200.423 125.963 199.695 125.176 199.726 124.259C199.76 123.316 200.546 122.598 201.486 122.647Z"
      fill="#0F2E52"
    />
    <path
      d="M167.837 95.6699L162.334 105.197L172.734 108.791L164.946 116.569L174.062 122.734L164.529 128.233L171.734 136.546L161.102 139.393L165.91 149.286L154.904 149.289L156.987 160.092L146.354 157.245L145.564 168.216L136.033 162.719L132.43 173.118L124.651 165.336L118.477 174.446L112.979 164.919L104.66 172.124L101.815 161.498L91.9153 166.307L91.9206 155.304L81.1116 157.39L83.9666 146.766L72.9899 145.98L78.4934 136.452L68.0934 132.859L75.8814 125.08L66.7654 118.916L76.2987 113.417L69.0931 105.104L79.7251 102.257L74.9175 92.3638L85.926 92.3651L83.843 81.5621L94.4758 84.4095L95.2662 73.4378L104.796 78.9351L108.4 68.5365L116.179 76.3179L122.35 67.204L127.848 76.7307L136.168 69.5256L139.013 80.1514L148.912 75.3425L148.907 86.3457L159.716 84.2597L156.861 94.8839L167.837 95.6699Z"
      fill="#EE1A64"
    />
    <path
      d="M115.786 105.432L115.112 104.171L120.523 101.322L115.459 100.998L115.376 100.843L117.954 96.494L112.535 99.3484L111.861 98.0878L119.448 94.0917L120.176 95.4527L117.617 99.7618L122.653 100.088L123.373 101.436L115.786 105.432Z"
      fill="#F4F7FC"
    />
    <path
      d="M120.606 110.85L118.861 107.584L117.046 107.849L116.313 106.479L125.391 105.268L126.199 106.78L120.093 113.55L119.365 112.188L120.604 110.845L120.606 110.85ZM121.554 109.818L124.328 106.8L120.255 107.388L121.556 109.823L121.554 109.818Z"
      fill="#F4F7FC"
    />
    <path
      d="M127.99 119.285C125.875 120.399 123.362 119.726 122.231 117.61L120.62 114.595L128.21 110.597L129.822 113.612C130.952 115.728 130.113 118.166 127.99 119.285ZM127.34 118.07C128.849 117.275 129.41 115.703 128.629 114.241L127.691 112.486L122.486 115.227L123.424 116.982C124.203 118.44 125.845 118.857 127.34 118.07Z"
      fill="#F4F7FC"
    />
    <path
      d="M128.587 126.702L127.392 127.331L124.898 122.663L132.499 118.658L134.963 123.272L133.769 123.901L131.979 120.551L130.002 121.592L131.645 124.668L130.46 125.293L128.817 122.217L126.763 123.299L128.582 126.704L128.587 126.702Z"
      fill="#F4F7FC"
    />
    <path
      d="M137.998 128.971L130.376 132.998L129.699 131.727L137.321 127.699L137.998 128.971Z"
      fill="#F4F7FC"
    />
    <path
      d="M142.048 136.622L134.454 140.622L133.926 139.635L137.144 133.299L131.991 136.014L131.317 134.752L138.911 130.752L139.438 131.739L136.22 138.075L141.373 135.36L142.048 136.622Z"
      fill="#F4F7FC"
    />
    <path
      d="M99.4632 100.251L104.54 97.5768L105.214 98.8388L100.214 101.473C99.3239 101.942 98.9716 102.789 99.5751 103.919C100.179 105.048 101.083 105.234 101.974 104.765L106.974 102.131L107.648 103.393L102.571 106.067C100.935 106.929 99.2558 106.238 98.359 104.559C97.4623 102.881 97.8267 101.113 99.4632 100.251Z"
      fill="#F4F7FC"
    />
    <path
      d="M105.155 110.356L104.359 108.866L101.592 110.323L100.918 109.061L108.512 105.061L110.154 108.133C110.887 109.505 110.389 111.174 109.032 111.888C108.056 112.403 106.853 112.233 106.015 111.521L103.996 114.822L103.258 113.441L105.158 110.361L105.155 110.356ZM105.475 108.278L106.443 110.088C106.799 110.756 107.653 110.998 108.358 110.626C109.063 110.255 109.34 109.418 108.983 108.75L108.016 106.939L105.475 108.278Z"
      fill="#F4F7FC"
    />
    <path
      d="M107.048 114.544L112.125 111.87L112.799 113.132L107.799 115.766C106.909 116.235 106.557 117.083 107.16 118.212C107.764 119.341 108.668 119.527 109.559 119.058L114.559 116.424L115.233 117.686L110.156 120.36C108.52 121.222 106.841 120.531 105.944 118.853C105.047 117.174 105.412 115.406 107.048 114.544Z"
      fill="#F4F7FC"
    />
    <path
      d="M115.897 129.022C113.829 130.112 111.545 129.378 110.344 127.131C109.068 124.743 109.916 122.119 112.093 120.972C114.269 119.826 116.946 120.622 118.176 122.924C118.955 124.381 118.889 126.001 118.165 127.213L116.966 126.452C117.46 125.689 117.498 124.568 116.961 123.564C116.095 121.943 114.302 121.424 112.753 122.24C111.204 123.056 110.641 124.786 111.562 126.507C112.306 127.9 113.476 128.378 114.618 128.069L113.247 125.503L114.362 124.915L116.412 128.751L115.893 129.025L115.897 129.022Z"
      fill="#F4F7FC"
    />
    <path
      d="M115.635 130.724L120.711 128.05L121.386 129.312L116.386 131.946C115.495 132.415 115.143 133.263 115.747 134.392C116.35 135.522 117.255 135.707 118.145 135.238L123.145 132.604L123.82 133.866L118.743 136.541C117.106 137.403 115.427 136.711 114.53 135.033C113.634 133.355 113.998 131.586 115.635 130.724Z"
      fill="#F4F7FC"
    />
    <path
      d="M120.891 142.977L119.145 139.711L117.331 139.976L116.598 138.606L125.676 137.396L126.484 138.908L120.377 145.677L119.65 144.316L120.888 142.973L120.891 142.977ZM121.839 141.946L124.611 138.923L120.537 139.511L121.839 141.946Z"
      fill="#F4F7FC"
    />
    <path
      d="M125.125 147.381L122.112 148.969L121.438 147.707L124.451 146.12L127.597 141.032L128.364 142.467L126.004 146.111L130.362 146.204L131.128 147.639L125.12 147.372L125.125 147.381Z"
      fill="#F4F7FC"
    />
  </svg>
);

HeaderCircleIcon.propTypes = {
  className: PropTypes.string,
};

HeaderCircleIcon.defaultProps = {
  className: '',
};
